/**
 * Centralna konfiguracja oferty.
 * Wklej prawdziwy adres checkoutu w CHECKOUT_URL przed publikacją.
 */
export const CHECKOUT_URL = '';

export const PRICE = '64,99 zł';
export const REGULAR_PRICE = '129,98 zł';
export const SAVINGS = '64,99 zł';
export const DISCOUNT_LABEL = 'Oferta premierowa: −50%';

export const DAILY_CAMPAIGN = {
  enabled: true,
  timezone: 'Europe/Warsaw',
  cutoff: '23:59:59',
  dateLabel: true,
  price: PRICE,
  checkoutUrl: CHECKOUT_URL,
};

export const REFUND_POLICY = {
  enabled: false,
  days: 0,
  text: '',
};

/** Link CTA: checkout, jeśli skonfigurowany — w przeciwnym razie sekcja oferty. */
export function ctaHref(): string {
  return CHECKOUT_URL || '#oferta';
}

export function ctaIsExternal(): boolean {
  return Boolean(CHECKOUT_URL);
}
